module.exports = __webpack_public_path__ + "img/arrow.292f082e.svg";